import { render, staticRenderFns } from "./Visit.vue?vue&type=template&id=2f36c036"
import script from "./Visit.vue?vue&type=script&lang=js"
export * from "./Visit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports